export const GET_QUIZ_TEST_DETAILS = "GET_QUIZ_TEST_DETAILS";
export const GET_QUIZ_QUESTIONS = "GET_QUIZ_QUESTIONS";
export const GET_QUIZ_TESTS_LIST = "GET_QUIZ_TESTS_LIST";
